/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:25:51
 * @FilePath: \mrc-ess-fronted\src\main.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-08-17 15:39:52
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import myMixin from "./mixin";
import store from "./store"; //狀態管理
import router from "./router";
import getBase from "@/util/mrc_base_init"; //高级参数获取
import "@/util/common"; //Common Func & Components
import vuetify from "@/plugins/vuetify";
Vue.use(myMixin);
// 语言配置
import i18n from "@/util/lang";
Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.config.silent = process.env.NODE_ENV === "development" ? false : true; //关闭警告
const langs = Object.keys(store.getters.allLangLabel);
const values = Object.values(store.getters.allLangLabel);
langs.forEach((item, index) => {
  if (item != "code" || item != "status" || item != "msg")
    i18n.mergeLocaleMessage(item, values[index]);
});
const urlTree = function async(params, url, from) {
  store.dispatch("updateSystemStatus", 0);
  Array.isArray(params) &&
    params.forEach((item) => {
      let isNo = true;
      if (item.url == url) {
        isNo = false;
        store.dispatch("setFunctionId", item.function_uuid).then(() => {
          // Vue.prototype.getBtnPermissionList(); //获取权限
        });
      }
      //权限判断from && from["name"] === null &&
      if (item.url != "") {
        store.dispatch("updateSystemStatus", 3).then(() => {
          if (
            url.indexOf("admin") != -1 &&
            item.url.indexOf("admin") &&
            url.indexOf(item.url) != -1
          ) {
            if (item.url === url) store.dispatch("updateSystemStatus", 0);
            else {
              if (url.indexOf(item.url + "/") != -1)
                store.dispatch("updateSystemStatus", 0);
            }
          } else {
            if (url.indexOf(item.url) != -1) {
              if (item.url === url) store.dispatch("updateSystemStatus", 0);
              else {
                if (url.indexOf(item.url + "/") != -1)
                  store.dispatch("updateSystemStatus", 0);
              }
            }
          }
        });
      }
      if (isNo && Array.isArray(item.menus_tree)) {
        urlTree(item.menus_tree, url, from);
      }
    });
};
// 全局路由拦截-
router.beforeEach((to, from, next) => {
  if (Vue.prototype.$Api.length) {
    Vue.prototype.$Api.map((item) => {
      item.api.abort();
    });
    // this.$Api.abort(); //切换页面时，阻止上个页面未完成的请求
  }
  store.dispatch("updateSystemStatus", 0);

  if (to.meta && to.meta["keepAlive"] !== undefined) {
    if (
      from.meta &&
      from.meta["cachePre"] !== undefined &&
      from.meta["cachePre"] === true
    ) {
      store.commit("SelectionRefresh", 1);
    } else {
      store.commit("SelectionRefresh", 0);
    }
  }
  if (to.matched.length === 0) {
    // 匹配路由
    //匹配前往的路由不存在
    next("/system/404");
  } else if (from.path === to.path) {
    return; //访问相同的页面
  } else if (to.fullPath.indexOf("/app/") != -1) {
    //app html
    next();
  } else if (
    to.fullPath.indexOf("/forget_password/") != -1 ||
    to.fullPath == "/net_error" ||
    to.fullPath == "/login" ||
    to.fullPath.indexOf("/dashboard") != -1
  ) {
    // 将菜单重置到仪表板
    if (
      to.fullPath == "/login" ||
      to.fullPath.indexOf("/forget_password/") != -1
    ) {
      store.commit("SET_NAVKEY", store.getters.curBaseKey); //排除忘记密码页面
    }
    // console.log("重置dashboard后，跳转！");
    next();
    return;
  } else if (!store.getters.userToken || !store.getters.defaultLang) {
    // 未登录
    next({
      path: "/login",
      replace: true,
    });
    return;
  } else {
    store.state.AppInfo
      ? urlTree(JSON.parse(store.state.AppInfo)["menus_tree"], to.path, from)
      : next({
          path: "/login",
          replace: true,
        });
    // 判断页面更改
    if (
      store.getters.isChanged === "true" ||
      store.getters.isChanged === true
    ) {
      if (from.fullPath === "/") {
        store.dispatch("setPageChange", false).then(() => {
          // console.log("输入地址，跳转！");
          next();
        });
      } else {
        //点击其他菜单切换
        Vue.prototype.$confirmWarn("refuseChange").then((res) => {
          if (res) {
            // console.log("判断页面修改后，跳转！");
            next();
          }
        });
      }
    } else if (from.fullPath === "/") {
      // console.log("不判断是否修改，直接输入地址，跳转！");
      next();
    } else {
      // console.log("正常跳转！");
      next();
    }
  }
  //获取基础数据
  if (
    !store.getters.defaultUTC &&
    to.fullPath != "/login" &&
    to.fullPath.indexOf("/app/") == -1
  ) {
    //html5网页不获取基础数据
    getBase(store.getters.userToken); //获取默认时区，全局下拉颜色
  }
});
// 全局后置钩子-常用于结束动画等
router.afterEach((to, from, next) => {
  // store.dispatch("setLoading", false);

  store.dispatch("setPageChange", false).then(() => {
    // 入口权限判断
    // if (
    //   to &&
    //   to.meta &&
    //   to.meta.entry &&
    //   !Vue.prototype.hasBtn(to.meta.entry)
    // ) {
    //   store.dispatch("updateSystemStatus", 3);
    // }
  });
});
//chunk error
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

// import posthog from "posthog-js";
// posthog.init("<ph_project_api_key>", { api_host: "<ph_instance_address>" });
/* eslint-disable no-new */
import { mapGetters } from "vuex";
export default new Vue({
  el: "#app",
  router,
  store,
  i18n,
  vuetify,
  components: { App },
  template: "<App/>",
  methods: {},
  computed: {
    ...mapGetters(["FunctionUuid", "userToken"]),
  },
  created() {},
  watch: {
    FunctionUuid: {
      handler(val) {
        if (val) {
          // this.getBtnPermissionList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    window.onload = function () {
      if (window.location.href.indexOf("/app/") == -1)
        //html5网页
        getBase(store.getters.userToken);
    };
  },
});

Vue.config.errorHandler = function (error, vm, info) {
  // if (info.toString().indexOf("callback for watcher") != -1) return;
  store.dispatch("updateSystemStatus", 2).then(() => {
    if (process.env.NODE_ENV != "production") {
      console.groupCollapsed(info);
      console.log(vm);
      console.error("(%s):%s ", "错误信息", error);
      console.groupEnd();
    }
  });
};
